import Reveal from "@/components/base/Reveal";

const SEGMENTS = [
  {
    label: "Agronegócio",
    img: "https://readdy.ai/api/search-image?query=Fotografia%20industrial%20premium%20e%20realista%20de%20m%C3%A1quinas%20agr%C3%ADcolas%20e%20equipamentos%20industriais%20em%20ambiente%20rural%20brasileiro%20com%20galp%C3%A3o%20de%20maquin%C3%A1rio%2C%20motores%20el%C3%A9tricos%20vis%C3%ADveis%2C%20ilumina%C3%A7%C3%A3o%20natural%20suave%2C%20metal%20realista%2C%20est%C3%A9tica%20B2B%20premium%2C%20sem%20texto%2C%20sem%20logotipos%2C%20sem%20elementos%20futuristas&width=800&height=600&seq=power-seg-agro&orientation=landscape",
  },
  {
    label: "Sucroenergético",
    img: "https://readdy.ai/api/search-image?query=Fotografia%20industrial%20premium%20e%20realista%20de%20usina%20sucroenerg%C3%A9tica%20brasileira%20com%20estruturas%20met%C3%A1licas%20industriais%20e%20equipamentos%20de%20processamento%2C%20motores%20el%C3%A9tricos%20industriais%2C%20ilumina%C3%A7%C3%A3o%20industrial%20moderada%2C%20metal%20realista%2C%20est%C3%A9tica%20B2B%20premium%2C%20sem%20texto%2C%20sem%20logotipos%2C%20sem%20elementos%20futuristas&width=800&height=600&seq=power-seg-sucro&orientation=landscape",
  },
  {
    label: "Indústria",
    img: "https://readdy.ai/api/search-image?query=Fotografia%20industrial%20premium%20e%20realista%20de%20galp%C3%A3o%20industrial%20brasileiro%20com%20linhas%20de%20produ%C3%A7%C3%A3o%20e%20m%C3%A1quinas%20pesadas%2C%20motores%20el%C3%A9tricos%20acoplados%2C%20ilumina%C3%A7%C3%A3o%20industrial%20cinematogr%C3%A1fica%20suave%2C%20metal%20realista%2C%20profundidade%20de%20campo%2C%20est%C3%A9tica%20B2B%20premium%2C%20sem%20texto%2C%20sem%20logotipos%2C%20sem%20elementos%20futuristas&width=800&height=600&seq=power-seg-industria&orientation=landscape",
  },
  {
    label: "Alimentos",
    img: "https://readdy.ai/api/search-image?query=Fotografia%20industrial%20premium%20e%20realista%20de%20linha%20de%20processamento%20de%20alimentos%20em%20ind%C3%BAstria%20brasileira%2C%20equipamentos%20de%20a%C3%A7o%20inoxid%C3%A1vel%2C%20motores%20el%C3%A9tricos%20industriais%2C%20ilumina%C3%A7%C3%A3o%20limpa%20e%20suave%2C%20metal%20realista%2C%20est%C3%A9tica%20B2B%20premium%2C%20sem%20texto%2C%20sem%20logotipos%2C%20sem%20elementos%20futuristas&width=800&height=600&seq=power-seg-alimentos&orientation=landscape",
  },
  {
    label: "Mineração",
    img: "https://readdy.ai/api/search-image?query=Fotografia%20industrial%20premium%20e%20realista%20de%20opera%C3%A7%C3%A3o%20de%20minera%C3%A7%C3%A3o%20brasileira%20com%20m%C3%A1quinas%20pesadas%20e%20equipamentos%20industriais%2C%20motores%20el%C3%A9tricos%20de%20grande%20porte%2C%20ilumina%C3%A7%C3%A3o%20industrial%20moderada%2C%20metal%20realista%2C%20est%C3%A9tica%20B2B%20premium%2C%20sem%20texto%2C%20sem%20logotipos%2C%20sem%20elementos%20futuristas&width=800&height=600&seq=power-seg-mineracao&orientation=landscape",
  },
  {
    label: "Saneamento",
    img: "https://readdy.ai/api/search-image?query=Fotografia%20industrial%20premium%20e%20realista%20de%20esta%C3%A7%C3%A3o%20de%20tratamento%20de%20%C3%A1gua%20e%20saneamento%20brasileira%20com%20bombas%20e%20tubula%C3%A7%C3%B5es%20industriais%2C%20motores%20el%C3%A9tricos%20acoplados%20a%20bombas%2C%20ilumina%C3%A7%C3%A3o%20limpa%2C%20metal%20realista%2C%20est%C3%A9tica%20B2B%20premium%2C%20sem%20texto%2C%20sem%20logotipos%2C%20sem%20elementos%20futuristas&width=800&height=600&seq=power-seg-saneamento&orientation=landscape",
  },
];

export default function Segments() {
  return (
    <section id="segmentos" className="bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6 md:py-24">
        <Reveal>
          <h2 className="text-center font-heading text-3xl font-extrabold tracking-tight text-foreground-950 md:text-4xl">
            Onde existe produção, existe movimento.
          </h2>
          <p className="mx-auto mt-3 max-w-2xl text-center text-base text-foreground-600">
            Atendemos diferentes setores que dependem de motores e equipamentos em operação.
          </p>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {SEGMENTS.map((seg, i) => (
            <Reveal key={seg.label} delay={i * 60}>
              <div className="group relative overflow-hidden rounded-lg border border-background-200">
                <img
                  src={seg.img}
                  alt={`Segmento ${seg.label} - Power Motores Elétricos`}
                  title={`${seg.label} - Power Motores Elétricos`}
                  className="h-52 w-full object-cover object-top transition-transform duration-300 group-hover:scale-[1.03]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-primary-950/80 via-primary-950/20 to-transparent" />
                <h3 className="absolute bottom-4 left-4 right-4 font-heading text-lg font-bold text-background-50">
                  {seg.label}
                </h3>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}